import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const dataDeletion: LegalDoc = {
  slug: "data-deletion",
  title: "Hướng dẫn xoá dữ liệu",
  metaTitle: "Xoá tài khoản và dữ liệu",
  metaDescription:
    "Cách yêu cầu xoá tài khoản và toàn bộ dữ liệu cá nhân khỏi Chốt Ca theo Luật Bảo vệ dữ liệu cá nhân 2025.",
  version: "2.0.0",
  effectiveDate: C.effectiveDate,
  intro: `Bạn có quyền yêu cầu xoá dữ liệu cá nhân của mình theo **Điều 4 và Điều 14 Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15**. Trang này nói rõ cách thực hiện, những gì bị xoá, những gì buộc phải giữ và giữ trong bao lâu.\n\n**Cam kết của Chốt Ca: khi bạn xoá tài khoản, chúng tôi xoá hết.** Chúng tôi không giữ lại hồ sơ của bạn để tiếp thị, không giữ lại số điện thoại để gọi lại, không chuyển hồ sơ của bạn sang trạng thái ẩn để dùng sau.`,
  sections: [
    {
      title: "1. Cách yêu cầu xoá",
      sections: [
        {
          title: "1.1. Tự xoá trong ứng dụng (khuyến nghị)",
          body: "Người tìm việc: mở ứng dụng Chốt Ca, vào **Tài khoản → Cài đặt → Xoá tài khoản**, đọc cảnh báo và xác nhận. Yêu cầu có hiệu lực ngay, không cần chờ nhân viên duyệt. Đây là cách nhanh nhất và không cần bạn chứng minh danh tính thêm lần nữa vì bạn đã đăng nhập.",
        },
        {
          title: "1.2. Nhà tuyển dụng",
          body: `Nhà tuyển dụng gửi yêu cầu xoá tài khoản doanh nghiệp từ email của chủ tài khoản tới **${C.dpoEmail}**. Chúng tôi xác nhận với người đại diện trước khi xoá, vì việc xoá ảnh hưởng tới toàn bộ tin tuyển dụng, đơn ứng tuyển và các thành viên khác trong tài khoản.`,
        },
        {
          title: "1.3. Qua email khi không truy cập được ứng dụng",
          body: `Gửi email **từ chính địa chỉ đã đăng ký** tới **${C.dpoEmail}**, tiêu đề "**Yêu cầu xoá dữ liệu**". Chúng tôi xác minh quyền kiểm soát địa chỉ email đó rồi xử lý. Bạn không cần nêu lý do.`,
        },
        {
          title: "1.4. Khi mất quyền truy cập email đăng ký",
          body: `Gửi yêu cầu tới ${C.email} kèm thông tin đủ để chúng tôi đối chiếu tài khoản, ví dụ họ tên, số điện thoại trong hồ sơ và thời điểm đăng ký gần đúng. Chúng tôi chỉ yêu cầu giấy tờ tuỳ thân khi thực sự không còn cách xác minh nào khác, chỉ dùng để đối chiếu và **xoá ngay ảnh giấy tờ sau khi đối chiếu xong**. Đội hỗ trợ phản hồi trong **03 ngày làm việc**.`,
        },
      ],
    },
    {
      title: "2. Những gì bị xoá",
      body: "Toàn bộ dữ liệu cá nhân gắn với tài khoản của bạn, cụ thể:",
      items: [
        "**Danh tính và liên hệ**: email, mật khẩu đã băm, liên kết đăng nhập Google hoặc Apple, họ tên, năm sinh, giới tính, số điện thoại, Zalo, Facebook, Instagram.",
        "**Hồ sơ**: quận đang ở, quê quán, chiều cao, cân nặng, thông tin hình xăm, tình trạng chỗ ở, trình độ học vấn, kỹ năng, ngoại ngữ, giới thiệu bản thân và toàn bộ lịch sử kinh nghiệm làm việc.",
        "**Hình ảnh**: ảnh đại diện và ảnh toàn thân, xoá cả tệp gốc trên kho lưu trữ.",
        "**Hồ sơ xác minh danh tính nếu có**: ảnh giấy tờ tuỳ thân, ảnh chân dung và số giấy tờ đã mã hoá. Xin lưu ý tính năng xác minh danh tính đối với Người tìm việc hiện đang tắt nên phần lớn tài khoản không có nhóm dữ liệu này.",
        "**Hoạt động**: đơn ứng tuyển, lời mời phỏng vấn, tin đã lưu, danh sách theo dõi, danh sách đã ẩn, cài đặt cá nhân, lịch sử thông báo.",
        "**Bản sao thông tin liên hệ** đã lưu trong các lời mời phỏng vấn đã chốt lịch.",
        "**Thiết bị**: mã thông báo đẩy và thông tin thiết bị, để bạn không nhận thêm thông báo nào.",
        "**Với Nhà tuyển dụng**: thông tin người liên hệ, tin tuyển dụng, ảnh cơ sở kinh doanh và hồ sơ đăng ký kinh doanh đã nộp.",
      ],
    },
    {
      title: "3. Những gì buộc phải giữ lại và vì sao",
      body: "Một số bản ghi phải được lưu theo nghĩa vụ pháp luật. Chốt Ca **tách các bản ghi này khỏi danh tính cá nhân** ở mức tối đa mà pháp luật cho phép:",
      items: [
        "**Hoá đơn và chứng từ kế toán** của Nhà tuyển dụng đã phát sinh giao dịch: lưu **10 năm** theo **Luật Kế toán 2015**. Đây là nghĩa vụ pháp lý bắt buộc và không thể xoá theo yêu cầu.",
        "**Nhật ký hệ thống và nhật ký bảo mật**: lưu **12 tháng** phục vụ điều tra sự cố theo **Điều 26 Luật An ninh mạng 2018**. Nhật ký này chứa mã định danh kỹ thuật, không chứa hồ sơ của bạn.",
        "**Hồ sơ khiếu nại, tranh chấp hoặc vụ việc đang được cơ quan có thẩm quyền xem xét**: lưu cho tới khi vụ việc kết thúc, sau đó xoá theo chu kỳ thông thường.",
        "**Dấu vết chống lạm dụng đối với tài khoản bị khoá vì vi phạm nghiêm trọng**: chúng tôi giữ một giá trị băm một chiều của định danh để ngăn tài khoản vi phạm quay lại. Giá trị này không thể đảo ngược thành email hay số điện thoại của bạn và không chứa thông tin cá nhân nào khác.",
      ],
    },
    {
      title: "4. Thời gian xử lý",
      items: [
        "**Ngay lập tức**: tài khoản ngừng hoạt động, bạn không đăng nhập được nữa, hồ sơ của bạn biến mất khỏi Kho ứng viên và khỏi mọi danh sách ứng viên, các lời mời đang chờ bị huỷ, thông báo đẩy dừng lại.",
        "**Trong 72 giờ**: dữ liệu cá nhân được xoá khỏi hệ thống chính và kho lưu trữ hình ảnh.",
        "**Trong 90 ngày**: dữ liệu được loại khỏi các bản sao lưu theo chu kỳ luân chuyển sao lưu. Trong khoảng thời gian này, các bản sao lưu được mã hoá, không dùng cho mục đích vận hành và chỉ dùng để khôi phục thảm hoạ.",
        "**Đăng nhập bằng Apple**: khi bạn xoá tài khoản, hệ thống gọi thu hồi mã truy cập phía Apple, theo yêu cầu của App Store. Bạn cũng có thể tự kiểm tra tại Cài đặt thiết bị, mục tài khoản Apple, phần đăng nhập bằng Apple.",
      ],
    },
    {
      title: "5. Sau khi xoá",
      items: [
        "Bạn không đăng nhập lại được và không khôi phục được lịch sử ứng tuyển, tin đã đăng hay lời mời cũ. **Việc xoá là không thể hoàn tác.**",
        "**Địa chỉ email của bạn được giải phóng ngay** và có thể dùng để đăng ký một tài khoản mới bất cứ lúc nào. Tài khoản mới bắt đầu từ con số không, không kế thừa dữ liệu cũ.",
        "Nhà tuyển dụng đã nhận thông tin liên hệ của bạn trước thời điểm xoá **vẫn có thể còn giữ bản ghi riêng của họ ngoài hệ thống Chốt Ca**. Chúng tôi không kiểm soát được các bản ghi đó. Theo **Điều 25 Luật Bảo vệ dữ liệu cá nhân 2025**, họ có nghĩa vụ xoá thông tin của người dự tuyển khi không tuyển dụng. Bạn liên hệ trực tiếp với họ để yêu cầu xoá, và báo cho chúng tôi nếu họ không thực hiện.",
      ],
    },
    {
      title: "6. Xoá một phần thay vì xoá cả tài khoản",
      body: "Nếu bạn chỉ muốn giảm mức độ hiển thị chứ chưa muốn mất tài khoản, các lựa chọn nhẹ hơn có sẵn trong ứng dụng:",
      items: [
        "**Tắt chế độ Đang tìm việc**: hồ sơ rời khỏi Kho ứng viên ngay, không Nhà tuyển dụng nào tìm thấy bạn nữa.",
        "**Ẩn một Nhà tuyển dụng cụ thể**: họ không thấy và không mời được bạn.",
        "**Xoá từng trường thông tin**: gỡ số điện thoại phụ, ảnh toàn thân, một mục kinh nghiệm hoặc liên kết mạng xã hội bất cứ lúc nào.",
        "**Tắt thông báo**: trong cài đặt ứng dụng hoặc cài đặt thiết bị.",
      ],
    },
    {
      title: "7. Quyền khiếu nại",
      body: `Nếu yêu cầu xoá của bạn không được xử lý đúng cam kết trên, hãy gửi khiếu nại tới ${C.dpoEmail}. Nếu vẫn chưa được giải quyết thoả đáng, bạn có quyền khiếu nại tới **cơ quan chuyên trách bảo vệ dữ liệu cá nhân thuộc Bộ Công an**, khởi kiện tại toà án có thẩm quyền, hoặc yêu cầu bồi thường thiệt hại theo quy định của pháp luật.`,
    },
  ],
  contact: {
    title: "8. Liên hệ",
    prefix: "Yêu cầu xoá dữ liệu và thực hiện quyền chủ thể dữ liệu: ",
    email: C.dpoEmail,
  },
};
